import { useEffect, useState } from "react"

export default function useClipboardAvailable() {
  const [clipboardAvailable, setClipboardAvailable] = useState(false)

  useEffect(() => {
    if (navigator && navigator.clipboard) {
      setClipboardAvailable(true)
    }
  }, [navigator])

  return clipboardAvailable
}
